<template>
  <div>
    <div class="card-title">{{ title }}</div>
    <div class="card-subtitle">{{ subTitle }}</div>
  </div>
</template>
<script>
export default({
  name: "card-title",
  props: {
    title: {
      type: String,
      default: '我要预约',
    },
    subTitle: {
      type: String,
      default: 'appointment',
    },
  },
})
</script>

<style scoped lang="scss">

</style>
